import { jsx as _jsx } from "react/jsx-runtime";
import { BrandFilter, BrandFilterItem, Box } from '@as/cotopaxi';
import { BrandListerGroupedFilterTypes } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useAemConfig } from '@as-react/common-components';
export const BrandListerFilters = ({ filters, onClick }) => {
    const { t } = useTranslation(I18N_NAMESPACES.brand);
    const { canonicalUrl } = useAemConfig();
    const getFilterTitle = (key) => {
        if (key === BrandListerGroupedFilterTypes.ALL) {
            return t('brandlister.overview.navigation.all');
        }
        else if (key === BrandListerGroupedFilterTypes.POPULAR) {
            return t('brandlister.overview.navigation.popular');
        }
        return key;
    };
    const getHref = (key) => {
        const url = new URL(canonicalUrl);
        url.searchParams.set('filter', key);
        return url.toString();
    };
    return (_jsx(Box, { mobile: {
            spacing: { marginTop: 3, marginBottom: 0.5 },
        }, children: _jsx(BrandFilter, { children: filters.map((filter) => (_jsx(BrandFilterItem, { title: getFilterTitle(filter.key), filterKey: filter.key, active: filter.active, href: getHref(filter.key), onClick: onClick }, filter.key))) }) }));
};
